var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      "\n    " +
        _vm._s(_vm.$t("block_confirmation.please_type_block")) +
        "\n    "
    ),
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.typed,
            expression: "typed"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: "typed",
          placeholder: _vm.$t("block_confirmation.type_block_here")
        },
        domProps: { value: _vm.typed },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.typed = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-danger",
        class: { disabled: !_vm.deleteButtonEnabled },
        attrs: { disabled: !_vm.deleteButtonEnabled },
        on: {
          click: function($event) {
            return _vm.$emit("clicked", true)
          }
        }
      },
      [_vm._v("\n        " + _vm._s(_vm.$t("actions.block")) + "\n    ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }